import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UserType } from '../../enums/shared-enums.enum';
import { TabNavigationService } from '@shared/services';
import { TabGroup, TabIndex } from '../../enums/tab.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent  {
  @Input() userType: UserType;
  @Input() id: number;
  @Output() redirectTo = new EventEmitter();

  constructor(private router: Router, private tabNavigationService: TabNavigationService) {}

  handleCloseEvent() {
    this.redirectTo.emit();
    if (this.router.url.includes('fleet')) {
      this.tabNavigationService.activatedTab$.next({ group: TabGroup.Provider, index: TabIndex.ProviderUsers });
    } 
    else if (this.router.url.includes('customer')) {
      this.tabNavigationService.activatedTab$.next({ group: TabGroup.Customer, index: TabIndex.CustomerUsers });
    }
  }
}
